// Theme: dark by default; the visitor can switch to light (remembered in localStorage).
// Applied as data-theme on <html>, which brand/tokens.css reads.
const KEY = "hs-theme";

export function storedTheme() {
  try {
    const v = window.localStorage.getItem(KEY);
    return v === "light" || v === "dark" ? v : null;
  } catch (_) { return null; }
}

export function applyTheme(theme) {
  document.documentElement.setAttribute("data-theme", theme === "light" ? "light" : "dark");
}

export function applyStoredTheme() { applyTheme(storedTheme() || "dark"); }

export function setTheme(theme) {
  applyTheme(theme);
  try { window.localStorage.setItem(KEY, theme); } catch (_) { /* private mode: not remembered */ }
}

export function currentTheme() {
  return document.documentElement.getAttribute("data-theme") === "light" ? "light" : "dark";
}
